export default __webpack_public_path__ + "static/media/Citroen-Bold.66968580.otf";